import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, NavigationError, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from '../../../services/notification.service';

interface Unread {
    unread: any[];
    currentUserId: string;
}

@Component({
    selector: 'app-unread-notifications-dialog',
    templateUrl: './unread-notifications-dialog.component.html',
    styleUrls: ['./unread-notifications-dialog.component.scss']
})
export class UnReadNotificationsDialogComponent implements OnInit, OnDestroy {

    private currentRoute: string = '';

    constructor(protected translate: TranslateService, public dialogRef: MatDialogRef<UnReadNotificationsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Unread, private router: Router, private notificationService: NotificationService) {

        // Backend sorts by count desc
        this.currentRoute = this.router.url;
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }

    gotoCase(message: any) {
        this.notificationService.markAsRead(this.data.currentUserId, { caseId: message.caseId });
        this.dialogRef.close();
        const caseId = message.caseId;
        this.router.navigateByUrl(`/case/${caseId}/notifications`).then(() => {
            if (this.currentRoute == `/case/${caseId}/notifications`)
                window.location.reload();
        });
    }

    gotoNotifications(message: any) {
        this.notificationService.markAsRead(this.data.currentUserId, { ids: message.ids });
        this.dialogRef.close();
        this.router.navigateByUrl(`/notifications`).then(() => {
            if (this.currentRoute == '/notifications')
                window.location.reload();
        });
    }
}
